export default __webpack_public_path__ + "static/media/logo-dark.25a92120.png";